import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import { CreditRequirements, ICreditRequirement } from '../../../../ng2/shared/constants/credit-requirements.constant';
import { CodeDeckUrl, ValidCourseCodeRegex } from '../../../../ng2/shared/constants/valid-course-code-regex.constant';
import { ImGapPlan } from '../../../../ng2/shared/services/im-models/im-gap-plan';
import { IGapPlan } from '../../../../ng2/shared/typings/interfaces/gap-plan.interface';

interface ITermYear {
  termYear: string;
  human: string;
}

export class CreditGapsFreeformCourseModalCtrl {
  static $inject = [
    'termType',
    'termYear',
    'modalTitle',
    'student',
    'school',
    'studentGapPlans',
    'GapPlan',
    '$mdDialog',
    'SDCStore',
    'sdcActions',
    'ErrorModal',
    'ImSchool',
    'UtilitiesService',
    'gapPlan',
    'ImGapPlan',
  ];

  public freeformModalForm;
  public creditReqs: ICreditRequirement[];
  public isValid = false;
  public freeformGapPlan: IGapPlan;
  public allTermYears: ITermYear[];
  public mode: 'EDIT' | 'ADD' = 'ADD';
  public selectedTermYear;
  public validCourseCodeRegex;
  public codeDeckUrl = CodeDeckUrl;

  constructor(
    private termType,
    private termYear,
    private modalTitle,
    private student,
    private school,
    private studentGapPlans,
    private GapPlan,
    private $mdDialog,
    private SDCStore,
    private sdcActions,
    private ErrorModal,
    private ImSchool: ImSchool,
    private utils: UtilitiesService,
    private existingGapPlan,
    private imGapPlan: ImGapPlan,
  ) {
    this.creditReqs = _.filter(CreditRequirements, (creditReq: any) => {
      return creditReq.orders.creditGapModal;
    });

    // Update term dropdown with values in case its needed
    this.allTermYears = this.buildTermYears(this.school, 12);
    // Set selected term year to the passed in term year
    this.selectedTermYear = _.find(this.allTermYears, { termYear: termYear.toString() });
    this.validCourseCodeRegex = ValidCourseCodeRegex;

    // Set variables based on whether an existing gapPlan is being edited
    if (existingGapPlan) {
      this.mode = 'EDIT';
      this.freeformGapPlan = _.cloneDeep(existingGapPlan);
    } else {
      this.freeformGapPlan = imGapPlan.createNew(null, school._id, student);
    }
  }

  // Build an array of term years, starting with the nextTermYear
  buildTermYears(school, numTermYears: number): ITermYear[] {
    const currentTermYear = this.ImSchool.getCurrentTermYear(this.school);
    let nextTermYear = currentTermYear;
    let counter = 0;

    const allTermYears = [
      {
        human: this.utils.getHumanReadableTerm(currentTermYear),
        termYear: currentTermYear.toString(),
      },
    ];

    while (counter < numTermYears) {
      nextTermYear = this.ImSchool.getNextTermYear(school, nextTermYear);
      const human = this.utils.getHumanReadableTerm(nextTermYear);
      allTermYears.push({
        human,
        termYear: nextTermYear.toString(),
      });
      counter++;
    }

    return allTermYears;
  }

  makePatch(newPlan, oldPlan) {
    const patch: any = {};

    if (newPlan.termYear !== oldPlan.termYear) {
      patch.termYear = newPlan.termYear;
    }

    if (newPlan.plan !== oldPlan.plan) {
      patch.plan = newPlan.plan;
    }

    if (newPlan.gradReq !== oldPlan.gradReq) {
      patch.gradReq = newPlan.gradReq;
    }

    if (newPlan.creditValue !== oldPlan.creditValue) {
      patch.creditValue = newPlan.creditValue;
    }

    if (_.size(patch)) {
      patch._id = newPlan._id;
      return patch;
    } else {
      return null;
    }
  }

  saveGapPlan(gapPlan) {
    gapPlan.termYear = parseInt(this.selectedTermYear.termYear);
    const patch = this.makePatch(gapPlan, this.existingGapPlan);

    if (!patch) {
      return this.closeModal();
    }

    return new this.GapPlan(patch)
      .$patch(patch)
      .then(updatedGapPlan => {
        // TODO: We need an updateGapPlan method on sdcActions
        const { _id } = updatedGapPlan;
        console.warn(`GapPlan ${_id} changes were saved successfully but may not display correctly in UI`);
        return updatedGapPlan;
      })
      .then(updatedGapPlan => {
        // For now, find the gapPlan in the array of studentGapPlans and patch
        const found = _.find(this.studentGapPlans, { _id: updatedGapPlan._id });
        _.forEach(patch, (val, key: string) => {
          if (key !== '_id') {
            found[key] = val;
          }
        });
      })
      .then(() => this.closeModal())
      .catch(error => {
        this.ErrorModal.show('Error adding gapPlan', error);
      });
  }

  createGapPlan(gapPlan): Promise<IGapPlan> {
    const termYear = this.selectedTermYear.termYear;
    gapPlan.termYear = parseInt(termYear);

    return gapPlan
      .$create()
      .then(gapPlan => {
        // Get anything off the store to confirm the store is loaded
        const uiState = this.SDCStore.getUiState();
        if (uiState) {
          this.sdcActions.addGapPlan(gapPlan);
        }
        return gapPlan;
      })
      .then(gapPlan => {
        // TODO: remove this .then block once the SSV is on the SDC Store (JC),
        // At that point, no need to push onto studentGapPlans array.
        this.studentGapPlans.push(gapPlan);
      })
      .then(() => this.closeModal())
      .catch(error => {
        this.ErrorModal.show('Error adding gapPlan', error);
      });
  }

  closeModal() {
    this.$mdDialog.hide();
  }
}
